import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';

const userTestimonials = [
  {
    initial: 'N',
    name: 'Nico',
    testimonial:
      "My favourite thing about TradesPad is the design, everything is clear, not confusing like other apps",
  },
  {
    initial: 'J',
    name: 'Jonah',
    testimonial:
      "I love that I can keep all my trading accounts together and check my total portfolio value in a quick view",
  },
  {
    initial: 'A',
    name: 'Aarav S.',
    testimonial:
      "This BETA is literally better than other fully launched apps, I can't imagine when they release the full version",
  },
  {
    initial: 'A',
    name: 'Aisha',
    testimonial:
      "Keeping my accounts, strategies, trades, payouts and everything in the same place made my mind clearer",
  },
  {
    initial: 'B',
    name: 'Bastien',
    testimonial:
      "I truly believe that every trader should use a journal like this, it's a need if you're a trader, and this one is perfect",
  },
];

export default function Testimonials() {
  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 8 },
        pb: { xs: 4, sm: 8 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      {/* Border line with gradient */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100vw',
          height: '1px',
          pointerEvents: 'none',
          zIndex: 2,
        }}
      />
      {/* Background gradient */}
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100vw',
          height: '400px',
          pointerEvents: 'none',
          zIndex: 0,
        })}
      />
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: 'center',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Typography
          sx={{
            color: '#797979',
            fontSize: '1rem',
            textAlign: 'center',
            mb: 1,
          }}
        >
          Reviews
        </Typography>
        <Typography
          component="h2"
          sx={{
            color: '#FFF',
            fontWeight: 500,
            fontSize: { xs: '2rem', sm: '2.75rem' },
            textAlign: 'center',
            lineHeight: 1.15,
          }}
        >
          What TradesPad users
          <br />
          thinks about us
        </Typography>
      </Box>
      <Grid container spacing={4} sx={{ position: 'relative', zIndex: 1, justifyContent: 'center' }}>
        {userTestimonials.map((testimonial, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3.5 }} key={index} sx={{ display: 'flex' }}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flexGrow: 1,
                backgroundColor: '#0C0C0C',
                border: '2px dashed #191818',
                borderRadius: '16px',
                backgroundImage: 'none',
                boxShadow: 'none',
                p: 2,
              }}
            >
              <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                <Typography
                  variant="body1"
                  sx={{ color: '#E8E8E8', mb: 0, fontSize: '0.95rem', fontWeight: 500 }}
                >
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Avatar
                  sx={{
                    bgcolor: '#1A1A1A',
                    color: '#FFF',
                    width: 44,
                    height: 44,
                    fontSize: '1rem',
                    fontWeight: 700,
                  }}
                >
                  {testimonial.initial}
                </Avatar>
                <Box>
                  <Typography sx={{ color: '#E8E8E8', fontWeight: 600, fontSize: '1rem' }}>
                    {testimonial.name}
                  </Typography>
                  <Typography sx={{ color: '#929292', fontSize: '0.85rem', fontWeight: 500 }}>
                    TradesPad BETA user
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: { xs: 2, sm: 2 }, textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <Typography
          sx={{
            color: '#616161',
            fontWeight: 600,
            fontSize: { xs: '1rem', sm: '1.2rem' },
          }}
        >
          Used by{' '}
          <Typography component="span" sx={{ color: '#FFF', fontWeight: 600, fontSize: 'inherit' }}>
            +4000 traders
          </Typography>{' '}
          worldwide
        </Typography>
      </Box>
    </Container>
  );
}
